export function CompareHoverMsg(msg1, msg2) {
  if (msg1 == msg2) return true;

  if (msg1 == null || msg2 == null) return false;

  if (msg1.fShortText != msg2.fShortText) return false;
  if (msg1.fLongText != msg2.fLongText) return false;
  if (msg1.fShortCutText != msg2.fShortCutText) return false;

  return true;
}
